var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.description)?_c('div',{staticClass:"dialog-field-desc"},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }